import React from 'react';

const PageTitle: React.FC = () => {
  const pageTitles = {
    '/ltimanagement/links': 'Link Manager',
    '/ltimanagement/link/create': 'Add New Link',
    '/ltimanagement/tools': 'LTI 1.3 Tool Configuration',
    '/ltimanagement/tool/create': 'Create Tool',
    '/import-logs': 'Import Log',
    '/ltimanagement/accessdenied': 'Access Denied',
  };
  const path = window.location.pathname.toLowerCase();
  const isEdit = path.includes('edit');
  const isEditLink = isEdit && path.includes('link');

  if (isEdit) {
    if (isEditLink) {
      document.title = 'Edit Link';
    } else {
      document.title = 'Edit Tool';
    }
  } else {
    document.title = pageTitles[path];
  }

  return null;
};

export default PageTitle;
